import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5985cd28"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我的卡包", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我的联卡", -1))
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "linkard-box" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text" }, "LINKARD"),
  /*#__PURE__*/_createElementVNode("span", { class: "line" })
], -1))
const _hoisted_5 = { class: "empty-card" }
const _hoisted_6 = {
  key: 0,
  class: "empty-card-text"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "您还未创建联卡", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "请使用电脑前往以下链接开始创建", -1))
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 1,
  class: "empty-card-text"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "该联卡不存在", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom_white" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", {
    class: "card-container",
    style: _normalizeStyle({ backgroundImage: `url(${_ctx.backgroundImg})` })
  }, [
    (_ctx.isMySelf)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "card-slider",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toMyFavorites && _ctx.toMyFavorites(...args)))
        }, [
          _createVNode(_component_van_image, {
            src: require('../assets/image/icon-card.png')
          }, null, 8, ["src"]),
          _hoisted_1
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "card-slider",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toMyLinkard && _ctx.toMyLinkard(...args)))
        }, [
          _createVNode(_component_van_image, {
            src: require('../assets/image/icon-card.png')
          }, null, 8, ["src"]),
          _hoisted_2
        ])),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_van_image, {
          src: require('../assets/image/icon-empty-card.svg')
        }, null, 8, ["src"]),
        (_ctx.isMySelf)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("a", { href: _ctx.pcJumpUrl }, _toDisplayString(_ctx.pcJumpUrl), 9, _hoisted_9)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
      ])
    ]),
    _hoisted_13
  ], 4))
}